function arsenalReferal(){ 
  // This should already be loaded as arsenal-referal.js
  // Used for lead and tracking
  // Disable dependant links as soon as possible
  setupDependantLinks();
  
  // reference to add my other scripts
  // they are nested at the same level
  var path = getScriptPath('arsenal-referal');
  
  addAsset(path+'arsenal-init.js', runArsenalInit);

  function runArsenalInit(){
    arsenalInit();
  }
}

/***************************************************
  Document init
***************************************************/
// DOM Loaded
document.addEventListener("DOMContentLoaded",
  function() {
    arsenalReferal();
  }
);